var exports = {
  "kL": "DMSidebarSkeleton.module__container___T3JTRT",
  "Kd": "DMSidebarSkeleton.module__containerMobile___T3JTRT",
  "wx": "DMSidebarSkeleton.module__header___T3JTRT",
  "Od": "DMSidebarSkeleton.module__mobileHeader___T3JTRT",
  "Fy": "DMSidebarSkeleton.module__mobileHeaderActions___T3JTRT",
  "P1": "DMSidebarSkeleton.module__scrollArea___T3JTRT",
  "Qs": "DMSidebarSkeleton.module__content___T3JTRT",
  "wh": "DMSidebarSkeleton.module__mobileContent___T3JTRT",
  "jH": "DMSidebarSkeleton.module__spacer___T3JTRT",
  "nM": "DMSidebarSkeleton.module__row___T3JTRT",
  "TZ": "DMSidebarSkeleton.module__mobileRow___T3JTRT",
  "u4": "DMSidebarSkeleton.module__rowContent___T3JTRT",
  "yW": "DMSidebarSkeleton.module__channelInfo___T3JTRT",
  "jn": "DMSidebarSkeleton.module__channelNameRow___T3JTRT",
  "$s": "DMSidebarSkeleton.module__channelSubtextRow___T3JTRT",
  "me": "DMSidebarSkeleton.module__separator___T3JTRT",
  "bV": "DMSidebarSkeleton.module__sectionHeader___T3JTRT",
  "o5": "DMSidebarSkeleton.module__channelList___T3JTRT",
  "US": "DMSidebarSkeleton.module__bottomSpacer___T3JTRT",
  "cB": "DMSidebarSkeleton.module__mobileFab___T3JTRT",
};

module.exports = exports;
